import { useTranslation } from 'react-i18next';

const AgencyConfirmationWarning = () => {
  const { t } = useTranslation();

  return (
    <div
      className="bd-callout bd-callout-danger"
      data-testid="agency-confirmed-warning"
    >
      <b>{t('pageChannels.directChannels.agencyConfirmedWarning')}</b>
    </div>
  );
};

export default AgencyConfirmationWarning;
